"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCartTotal = void 0;
const getCartTotal = (golf_line) => {
    let val = 0;
    if (golf_line?.carts?.enabled === false)
        return val;
    if (golf_line?.carts?.types === null)
        return val;
    if (golf_line?.carts?.types?.length === 0)
        return val;
    golf_line?.carts?.types
        ?.filter((type) => type.quantity > 0)
        .map(
    // eslint-disable-next-line array-callback-return
    (cart_type, idx) => {
        if (golf_line?.carts?.types)
            val += golf_line?.carts?.types[idx]?.total;
    });
    return val;
};
exports.getCartTotal = getCartTotal;
